import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as clientActions from '../../actions/clientActions';
import * as userActions from '../../actions/userActions';
import * as authActions from '../../actions/authActions';

import { useClient } from '../../contexts';
import { ClientContextType } from '../../contexts/Client/types';
import { CookieBanner, FullPageSpinner } from '../../ui';

import styles from './App.module.css';
import { Status } from '../../reducers/authReducer';

type AppPropsType = {
  fetchClient: (client: ClientContextType) => void;
  fetchMe: () => void;
  setStatus: (status: Status) => void;
};

// To avoid winding up with a large bundle,
// we use react-lazy api to code splitting our application
// and create multiple bundles that can be dynamically loaded at runtime.
// https://reactjs.org/docs/code-splitting.html
const AppAuthenticated = React.lazy(
  () => import(/* webpackPrefetch: true */ './App-authenticated')
);
const AppUnauthenticated = React.lazy(() => import('./App-unauthenticated'));

const App: React.FC<AppPropsType> = ({ fetchClient, fetchMe, setStatus }) => {
  const client = useClient();
  const { status } = client;

  useEffect(() => {
    fetchClient(client);
  }, [client, fetchClient]);

  useEffect(() => {
    setStatus(status);
    if (status === 'authenticated') {
      fetchMe();
    }
  }, [status, fetchMe, setStatus]);

  if (status === 'loading') {
    return <FullPageSpinner />;
  }
  return (
    <div className={styles.root}>
      <React.Suspense fallback={<FullPageSpinner />}>
        {status === 'authenticated' ? (
          <AppAuthenticated />
        ) : (
          <AppUnauthenticated />
        )}
      </React.Suspense>
      <CookieBanner />
    </div>
  );
};

export default connect(null, {
  ...clientActions,
  ...userActions,
  ...authActions,
})(App);
